import React from 'react'
import { Link } from "react-router-dom"
import PropTypes from 'prop-types'
import { Row, Col, Space, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons';
import StorageUtils from '../utils/StorageUtils'
import { isExpired } from "react-jwt"
import Tomato from '../images/tomato-logo.svg'

const { SubMenu } = Menu;

class MainNav extends React.Component {
    state = {
        isLogin: false
    }

    // componentWillReceiveProps 生命周期函数已不建议使用，所以改用此函数
    static getDerivedStateFromProps(props, state) {
        return { isLogin: props.isLogin }
    }

    componentDidMount() {
        const { access, refresh } = StorageUtils.getUser()
        const accessTokenIsExpired = isExpired(access)
        const refreshTokenIsExpired = isExpired(refresh)
        
        if (refreshTokenIsExpired) {
            StorageUtils.removeUser()
        }

        if (!refreshTokenIsExpired || !accessTokenIsExpired) {
            this.setState({isLogin: true})
        }
    }

    render () {
        const { isLogin } = this.state

        const userNav = () => {
            if (!isLogin) {
                return <React.Fragment><Menu.Item key="login" ><Link to="/user/login">Login</Link></Menu.Item><Menu.Item key="register" ><Link to="/user/register">Register</Link></Menu.Item></React.Fragment>
            } else {
                return <React.Fragment><Menu.Item key="account" ><Link to="/user/account">Account</Link></Menu.Item><Menu.Item key="logout" ><Link to="/user/logout">Logout</Link></Menu.Item></React.Fragment>
            }
        }

        return (
            <Row justify="space-around">
                <Col span={5} push={1}>
                    <Space>
                        <Link to="/"><img style={{width: 50}} src={Tomato} /></Link>
                        <h2 style={{fontFamily: "Garamond", lineHeight: "60px"}}>Tomato</h2>
                    </Space>
                </Col>
                <Col span={18}>
                    <Row justify="end">
                        <Col>
                            <Menu mode="horizontal">
                                <Menu.Item key="home" >
                                    <Link to="/">Home</Link>
                                </Menu.Item>
				<SubMenu key="search" popupOffset={[0,-5]} title={<span>Search <DownOutlined /></span>}>
                                    <Menu.Item key="feature">
                                        <Link to="/search/feature">Search Gene and Transcripts</Link>
                                    </Menu.Item>
                                    <Menu.Item key="evaluation">
                                        <Link to="/search/trait">Search Trait Evaluation</Link>
                                    </Menu.Item>
                                </SubMenu>
                                <SubMenu key="tools" popupOffset={[0,-5]} title={<span>Tools <DownOutlined /></span>}>
                                    <Menu.Item key="id_converter">
                                        <Link to="/tool/id_converter">Gene ID Converter</Link>
                                    </Menu.Item>
                                    <Menu.Item key="blast">
                                        <a href="/tomato/tool/blast" target="_blank">Blast</a>
                                    </Menu.Item>
                                    <Menu.Item key="jbrowse">
                                        <Link to="/tool/jbrowse_nav">Jbrowse</Link>
                                    </Menu.Item>
                                    <Menu.Item key="gwasviz">
                                        <Link to="/tool/gwasviz">GWAS Visualizer</Link>
                                    </Menu.Item>
                                    <Menu.Item key="eqtlviz">
                                        <Link to="/tool/eqtlviz">eQTL Visualizer</Link>
                                    </Menu.Item>
                                    <Menu.Item key="pop_expression">
                                        <Link to="/tool/pop_expression">Population Gene Expression</Link>
                                    </Menu.Item>
                                    <Menu.Item key="crispr">
                                        <Link to="/search/crispr">CRISPR</Link>
                                    </Menu.Item>
                                    <Menu.Item key="snp_primer">
                                        <Link to="/tool/snp_primer">KASP Primer</Link>
                                    </Menu.Item>
                                    <Menu.Item key="gene_network">
                                        <Link to="/tool/gene_network">Gene Network</Link>
                                    </Menu.Item>
                                    <Menu.Item key="primer3">
                                        <a href="/tomato/tool/primer3" target="_blank">Primer3 Server</a>
                                    </Menu.Item>
                                </SubMenu>
                                <SubMenu key="help" popupOffset={[0,-5]} title={<span>Help <DownOutlined /></span>}>
                                    <Menu.Item key="aboutus">
                                        <Link to="/about">About us</Link>
                                    </Menu.Item>
                                    <Menu.Item key="news" disabled>
                                        <Link to="/news">News</Link>
                                    </Menu.Item>
                                    <Menu.Item key="tutorial" disabled>
                                        <Link to="/tutorial">Tutorial</Link>
                                    </Menu.Item>
                                    <Menu.Item key="sl5" disabled>
                                        <Link to="/help/sl5.0">SL5.0</Link>
                                    </Menu.Item>
                                    <Menu.Item key="data_source" disabled>
                                        <Link to="/dataSource">Data Source</Link>
                                    </Menu.Item>
                                    <Menu.Item key="contributors" disabled>
                                        <Link to="/contributors">Contributors</Link>
                                    </Menu.Item>
                                    <Menu.Item key="acknowledgements" disabled>
                                        <Link to="/acknowledgements">Acknowledgements</Link>
                                    </Menu.Item>
                                    <Menu.Item key="publications" disabled>
                                        <Link to="/publications">Publications</Link>
                                    </Menu.Item>
                                </SubMenu>
                            </Menu>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }
}

MainNav.propTypes = {
    isLogin: PropTypes.bool
}

export default MainNav
